"use strict";
exports.__esModule = true;
var GatewayModule = /** @class */ (function () {
    function GatewayModule(gatewayClient) {
        this.gatewayClient = gatewayClient;
    }
    return GatewayModule;
}());
exports.GatewayModule = GatewayModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2F0ZXdheS1tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9nYXRld2F5LW1vZHVsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBO0lBR0UsdUJBQVksYUFBNEI7UUFDdEMsSUFBSSxDQUFDLGFBQWEsR0FBRyxhQUFhLENBQUM7SUFDckMsQ0FBQztJQUNILG9CQUFDO0FBQUQsQ0FBQyxBQU5ELElBTUM7QUFOcUIsc0NBQWEifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/gateway-module.js
// module id = 2
// module chunks = 44